import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=7cd8877c&scoped=true&"
import script from "./Back.vue?vue&type=script&lang=js&"
export * from "./Back.vue?vue&type=script&lang=js&"
import style0 from "./Back.vue?vue&type=style&index=0&id=7cd8877c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd8877c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/ubq-h5_build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd8877c')) {
      api.createRecord('7cd8877c', component.options)
    } else {
      api.reload('7cd8877c', component.options)
    }
    module.hot.accept("./Back.vue?vue&type=template&id=7cd8877c&scoped=true&", function () {
      api.rerender('7cd8877c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/base/Back.vue"
export default component.exports